import { combineReducers } from 'redux';
import { reducer as mainReducer } from './main';
import { reducer as userReducer } from './user';

const rootReducer = combineReducers({
  main: mainReducer,
  user: userReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/modules/reducers.js